module.exports = __webpack_public_path__ + "static/media/upload-onclick.f9f046d3.svg";